import React from "react";
import Fit from "./Fit";
import "./HeldUp.scss";

const PrintUnfitCertificate = () => {
  return <Fit noHeader />;
};
export default PrintUnfitCertificate;
